import { gql } from 'graphql-tag'

export const leagueReportQuery = gql`
  query LeagueReport {
    me {
      id
      teacher {
        id
        root {
          id
          rankingRootWithTier
        }
      }
    }
  }
`

export const leagueBoardsQuery = gql`
  query LeagueBoards {
    me {
      id
      reader {
        id
        getCurrentPoints
        overallRanking(neighbors: 2) {
          points
          tier
          percentage
          rankingUsers {
            entityId
            profileId
            rankPosition
            rootName
            totalTimeSpent
            points
            userName
          }
        }
        overallRankingHistory {
          points
          month
          rankPosition
          tier
          status
        }
        entity {
          id
          degree
          ancestry
          rankingEntity {
            profileId
            rankPosition
            rootName
            tier
            totalTimeSpent
            points
            userName
          }
          rankingSchool {
            profileId
            rankPosition
            rootName
            tier
            totalTimeSpent
            points
            userName
          }
          rankingRoot {
            profileId
            rankPosition
            rootName
            tier
            totalTimeSpent
            points
            userName
          }
        }
      }
    }
  }
`

export const leaguePointsQuery = gql`
  query LeaguePoints {
    me {
      id
      reader {
        id
        getCurrentPoints
        overallRanking {
          points
          tier
          percentage
        }
      }
    }
  }
`
